import * as React from 'react'
import autocomplete from 'autocomplete.js'
import StandardInput from './standard-input'
import { omit } from 'lodash'
import { withSuburbAutoComplete } from  '../../common/modules/suburb-auto-complete'

@withSuburbAutoComplete
export default class extends React.Component<any, any>{


    componentDidMount(){
        const config = this.props.config;
        const inputElementId = "#" + this.props.field.replace(".", "-");
        const displayKey = inputElementId;
        const isPostal = this.props.isPostal;
        const field = this.props.field;
        const stateField = this.props.stateField;
        const postcodeField = this.props.postcodeField;
        const addressNotFoundField = this.props.addressNotFoundField;
        const updateField = this.props.updateField;
        const clearFields = this.props.clearFields;
        const props = this.props;

        autocomplete(inputElementId, { hint: false }, [{
                source(query, callback){
                    const axios = props.suburbAutoComplete.axios
                    const endpoint = props.suburbAutoComplete.endpoint
                
                    axios
                    .get(`${endpoint}?suburb=${query}`, {})
                    .then(response => {
                        callback(response.data)
                    })
                },
                delay: 1000,
                templates:{
                    suggestion: function(suggestion){
                        return suggestion.suburb + " - " + suggestion.state + " " + suggestion.postcode;
                    }
                }
            },
        ]).on('autocomplete:shown', function(){
            updateField(stateField, '');
            updateField(postcodeField, '');
        }).on('autocomplete:selected', function(event, suggestion, dataset){
            if(addressNotFoundField) clearFields([ addressNotFoundField ]);
            updateField(field, suggestion.suburb);
            updateField(stateField, suggestion.state);
            updateField(postcodeField, suggestion.postcode);
           
            return suggestion.suburb;
        })
    }


    render(){
        return <StandardInput { ...this.props } blurHack={ true } />
    }

}






// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/suburb-auto-complete.tsx